import React, { useEffect, useState } from "react";

interface CampManagedBannerProps {
  workflowStatus?: string | null;
  className?: string;
  heightPx?: number;
  borderBottomOnly?: boolean;
}

/**
 * Full-bleed banner shown when a location is camp-managed.
 * Displays for workflowStatus == 'wf_internal30' or 'wf_external4'.
 * Height: 30px, background 953fe0 @ 12% opacity, 1px solid border 953fe0, text color 953fe0.
 */
export const CampManagedBanner: React.FC<CampManagedBannerProps> = ({ workflowStatus, className, heightPx = 30, borderBottomOnly = false }) => {
  const isCampManaged = workflowStatus === 'wf_internal30' || workflowStatus === 'wf_external4';
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Reset dismissal on new sessions (sessionStorage scope)
    const value = sessionStorage.getItem('kb_hide_camp_managed_banner');
    setDismissed(value === '1');
    // Clear dismissal on hard refresh/new navigation so it reappears
    const handleBeforeUnload = () => {
      try { sessionStorage.removeItem('kb_hide_camp_managed_banner'); } catch (err) {
        // Ignore sessionStorage errors (private mode, etc.)
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  if (!isCampManaged || dismissed) return null;

  return (
    <div
      className={className}
      style={{
        width: '100%',
        height: heightPx,
        backgroundColor: 'rgba(149, 63, 224, 0.12)',
        border: borderBottomOnly ? 'none' : '1px solid #953fe0',
        borderBottom: '1px solid #953fe0',
        color: '#953fe0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      <div className="flex items-center gap-2 text-sm" style={{ lineHeight: `${heightPx}px`, paddingLeft: 8, paddingRight: 8, display: 'inline-flex' }}>
        <img
          src={
            'https://firebasestorage.googleapis.com/v0/b/kb-prod-fb-proj.appspot.com/o/app%2Ficons%2Fcampmgd.svg?alt=media&token=85cea0b5-3a14-43df-8212-26bba383ba4b'
          }
          alt="Camp managed"
          style={{ width: 20, height: 20 }}
        />
        <span><strong>Camp-Managed</strong> — You're in the driver's seat! The KidsBooked team won't change this content unless requested.</span>
        <button
          aria-label="Dismiss"
          onClick={() => { sessionStorage.setItem('kb_hide_camp_managed_banner', '1'); setDismissed(true); }}
          style={{
            border: 'none',
            background: 'transparent',
            color: '#953fe0',
            cursor: 'pointer',
            lineHeight: `36px`,
            fontSize: 24,
            position: 'absolute',
            right: 24,
            top: 0
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default CampManagedBanner;


